import {Link, Image} from '@chakra-ui/react';

import {DownloadAppBanner} from './download-banner';
import {Competition} from '../types';

export function SponsorImage({sponsors}: {sponsors: Competition['sponsors']}) {
  const sponsor = sponsors?.[0];

  return sponsor ? (
    <Link
      alignSelf="center"
      target="_blank"
      cursor={sponsor.image_link ? 'pointer' : 'initial'}
      href={sponsor.image_link ?? undefined}
      width={['100%', null, '579px']}
      height={['82px', null, '125px']}
      mb="6"
    >
      <Image borderRadius="md" alt="sponsor" h="100%" w="100%" src={sponsor.image?.original} objectFit="contain" />
    </Link>
  ) : (
    <DownloadAppBanner alignSelf="center" mb="4" />
  );
}
